var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.75C8.04 0.75 0.75 8.04 0.75 17C0.75 25.96 8.04 33.25 17 33.25C25.96 33.25 33.25 25.96 33.25 17C33.25 8.04 25.96 0.75 17 0.75ZM17 3.25C24.6087 3.25 30.75 9.39125 30.75 17C30.75 24.6087 24.6087 30.75 17 30.75C9.39125 30.75 3.25 24.6087 3.25 17C3.25 9.39125 9.39125 3.25 17 3.25ZM12.275 10.475L10.475 12.275L15.205 17L10.4775 21.725L12.2775 23.525L17 18.7962L21.725 23.5212L23.525 21.725L18.7962 17L23.5212 12.275L21.725 10.475L17 15.205L12.275 10.4775V10.475Z",
    fill: "#D92C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.95376533f78aeda35371d3dd055851da.svg";
export { ForwardRef as ReactComponent };